// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25335
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 25335 
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils'
export const PageId = Object.freeze({
  OrderCenter_List: 'OrderCenter_List'
})

interface IPVTrackParamsRecord {
  /** 订单列表页 */
OrderCenter_List: {
/** 来源页面  */
from_page: string,
/** tab名称  */
tab_name: string}
}

const sendPv = {
  /** PV-订单列表页 */
OrderCenter_List: (page_param: IPVTrackParamsRecord['OrderCenter_List']) => {
    eventTrackingUtils.submitPV({page_id:PageId.OrderCenter_List,page_param});
  },
}

interface IExpoTrackParamsRecord {
  /** tab选择楼层曝光 */
OrderList_OrderTypeTabExpo: {
/** tab名称  */
tab_name: string}
  /** 再次购买button曝光 */
OrderList_BuyAgainExpo: {
/** tab名称  */
tab_name: string,
/** 位置  */
index: number,
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 发票服务button曝光 */
OrderList_InvoiceServiceExpo: {
/** tab名称  */
tab_name: string,
/** 位置  */
index: number,
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 删除订单button曝光 */
OrderList_DeleteButtonExpo: {
/** tab名称  */
tab_name: string,
/** 位置  */
index: number,
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 订单列表_订单卡片曝光 */
OrderList_OrderDetailExpo: {
/** tab名称  */
tab_name: string,
/** 位置  */
index: number,
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 订单跟踪button曝光 */
OrderList_OrderTrackExpo: {
/** tab名称  */
tab_name: string,
/** 位置  */
index: number,
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 空状态下再次尝试button曝光 */
OrderList_TryAgainExpo: {
/** tab名称  */
tab_name: string}
  /** 删除订单弹窗曝光 */
OrderList_DeletePopExpo: {
/** tab名称  */
tab_name: string,
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 位置  */
index: number,
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 评价button曝光 */
OrderList_ReviewExpo: {
/** tab名称  */
tab_name: string,
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 位置  */
index: number,
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 立即支付按钮曝光 */
OrderList_PayNowExpo: {
/** tab名称  */
tab_name: string,
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 位置  */
index: number,
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 再次支付弹窗曝光 */
OrderList_Repay_Pop_Expo: undefined
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** tab选择楼层曝光 */
  OrderList_OrderTypeTabExpo:'OrderList_OrderTypeTabExpo',
/** 再次购买button曝光 */
  OrderList_BuyAgainExpo:'OrderList_BuyAgainExpo',
/** 发票服务button曝光 */
  OrderList_InvoiceServiceExpo:'OrderList_InvoiceServiceExpo',
/** 删除订单button曝光 */
  OrderList_DeleteButtonExpo:'OrderList_DeleteButtonExpo',
/** 订单列表_订单卡片曝光 */
  OrderList_OrderDetailExpo:'OrderList_OrderDetailExpo',
/** 订单跟踪button曝光 */
  OrderList_OrderTrackExpo:'OrderList_OrderTrackExpo',
/** 空状态下再次尝试button曝光 */
  OrderList_TryAgainExpo:'OrderList_TryAgainExpo',
/** 删除订单弹窗曝光 */
  OrderList_DeletePopExpo:'OrderList_DeletePopExpo',
/** 评价button曝光 */
  OrderList_ReviewExpo:'OrderList_ReviewExpo',
/** 立即支付按钮曝光 */
  OrderList_PayNowExpo:'OrderList_PayNowExpo',
/** 再次支付弹窗曝光 */
  OrderList_Repay_Pop_Expo:'OrderList_Repay_Pop_Expo',
})

interface IClickTrackParamsRecord {
  /** 订单状态tab */
OrderList_OrderTypeTab: {
/** tab名称  */
tab_name: string}
  /** 点击订单(进入订单详情页) */
OrderList_OrderDetail: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** tab名称  */
tab_name: string,
/** 位置  */
index: number,
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 订单跟踪button */
OrderList_OrderTrack: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** tab名称  */
tab_name: string,
/** 位置  */
index: number,
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 再次购买button */
OrderList_BuyAgain: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** tab名称  */
tab_name: string,
/** 位置  */
index: number,
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 发票服务button */
OrderList_InvoiceService: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** tab名称  */
tab_name: string,
/** 位置  */
index: number,
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 删除订单button */
OrderList_DeleteButton: {
/** tab名称  */
tab_name: string,
/** 位置  */
index: number,
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 取消删除按钮(删除订单弹窗) */
OrderList_CancelDelete: {
/** tab名称  */
tab_name: string,
/** 位置  */
index: number,
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 确认删除按钮(删除订单弹窗) */
OrderList_ComfirmDelete: {
/** tab名称  */
tab_name: string,
/** 位置  */
index: number,
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 空状态下再次尝试button */
OrderList_TryAgain: {
/** tab名称  */
tab_name: string}
  /** 评价button */
OrderList_Review: {
/** tab名称  */
tab_name: string,
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 位置  */
index: number,
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 立即支付按钮点击 */
OrderList_PayNow: {
/** tab名称  */
tab_name: string,
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 位置  */
index: number,
/** 页码  */
page: number,
/** 包裹数量  */
packageNum: string}
  /** 再次支付弹窗点击 */
OrderList_Relay_Pop: {
/** 支付方式  */
payWay: string,
/** 渠道名称  */
channelName: string}
}

const sendClickTrack = {
  /** 点击事件上报-订单状态tab */
OrderList_OrderTypeTab: (json_param: IClickTrackParamsRecord['OrderList_OrderTypeTab']) => {
    eventTrackingUtils.submitCL({event_id:'OrderList_OrderTypeTab',json_param});
  },
  /** 点击事件上报-点击订单(进入订单详情页) */
OrderList_OrderDetail: (json_param: IClickTrackParamsRecord['OrderList_OrderDetail']) => {
    eventTrackingUtils.submitCL({event_id:'OrderList_OrderDetail',json_param});
  },
  /** 点击事件上报-订单跟踪button */
OrderList_OrderTrack: (json_param: IClickTrackParamsRecord['OrderList_OrderTrack']) => {
    eventTrackingUtils.submitCL({event_id:'OrderList_OrderTrack',json_param});
  },
  /** 点击事件上报-再次购买button */
OrderList_BuyAgain: (json_param: IClickTrackParamsRecord['OrderList_BuyAgain']) => {
    eventTrackingUtils.submitCL({event_id:'OrderList_BuyAgain',json_param});
  },
  /** 点击事件上报-发票服务button */
OrderList_InvoiceService: (json_param: IClickTrackParamsRecord['OrderList_InvoiceService']) => {
    eventTrackingUtils.submitCL({event_id:'OrderList_InvoiceService',json_param});
  },
  /** 点击事件上报-删除订单button */
OrderList_DeleteButton: (json_param: IClickTrackParamsRecord['OrderList_DeleteButton']) => {
    eventTrackingUtils.submitCL({event_id:'OrderList_DeleteButton',json_param});
  },
  /** 点击事件上报-取消删除按钮(删除订单弹窗) */
OrderList_CancelDelete: (json_param: IClickTrackParamsRecord['OrderList_CancelDelete']) => {
    eventTrackingUtils.submitCL({event_id:'OrderList_CancelDelete',json_param});
  },
  /** 点击事件上报-确认删除按钮(删除订单弹窗) */
OrderList_ComfirmDelete: (json_param: IClickTrackParamsRecord['OrderList_ComfirmDelete']) => {
    eventTrackingUtils.submitCL({event_id:'OrderList_ComfirmDelete',json_param});
  },
  /** 点击事件上报-空状态下再次尝试button */
OrderList_TryAgain: (json_param: IClickTrackParamsRecord['OrderList_TryAgain']) => {
    eventTrackingUtils.submitCL({event_id:'OrderList_TryAgain',json_param});
  },
  /** 点击事件上报-评价button */
OrderList_Review: (json_param: IClickTrackParamsRecord['OrderList_Review']) => {
    eventTrackingUtils.submitCL({event_id:'OrderList_Review',json_param});
  },
  /** 点击事件上报-立即支付按钮点击 */
OrderList_PayNow: (json_param: IClickTrackParamsRecord['OrderList_PayNow']) => {
    eventTrackingUtils.submitCL({event_id:'OrderList_PayNow',json_param});
  },
  /** 点击事件上报-再次支付弹窗点击 */
OrderList_Relay_Pop: (json_param: IClickTrackParamsRecord['OrderList_Relay_Pop']) => {
    eventTrackingUtils.submitCL({event_id:'OrderList_Relay_Pop',json_param});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
  sendPv,
}
export type {
  IExpoTrackParamsRecord,
}